
export const accessToken = 'pk.eyJ1Ijoiam91cm5leXdvcmtzIiwiYSI6ImNrYW9idjdrejFpcWYyeG82Nm5samN1c2EifQ.NWrhn6_O0JP5jHwcqFf48Q'

export const mapStyle = 'mapbox://styles/journeyworks/ckaobyght2l331in44sd6fylu'

export const mapConfig = {
  zoom: 12.04,
  center: [4.701801, 51.767419]
}

export const planMode = false

export const layers = {
  almere: {
    hexagons: {
      url: 'mapbox://journeyworks.5i4p3mql',
      source: "platform31_almere_codering-2dpu0m",
      active: true
    },
    border: {
      url: "mapbox://journeyworks.2rs0cmh3",
      source: "almere_de_marken_buurtdata_1-3q874y",
      active: true
    },
    blokken_manual: {
      url: "mapbox://",
      source: "",
      active: false
    },
    blokken_auto: {
      url: "mapbox://journeyworks.ac9vpdub",
      source: "almere_de_marken_bouwblokken-d3xivv",
      active: true
    },
  },
  hilversum: {
    hexagons: {
      url: 'mapbox://journeyworks.1ht88mrc',
      source: "platform31_hilversum_codering-7hspzg",
      active: true
    },
    border: {
      url: "mapbox://journeyworks.7141jm8r",
      source: "Platform31_hilversum_buurtinf-2ako38",
      active: true
    },
    blokken_manual: {
      url: "mapbox://journeyworks.8gz9wq89",
      source: "3buurtenhilversum_bouwblok_ha-dgg6vl",
      active: true
    },
    blokken_auto: {
      url: "mapbox://journeyworks.catz7tlk",
      source: "3buurtenhilversum_bouwblok_au-1w6aeq",
      active: true
    },
  },
  
}

